<div class="min-h-screen grid lg:grid-cols-2 bg-glico-fundo">
  <!-- Painel da marca -->
  <aside class="hidden lg:flex relative overflow-hidden bg-gradient-to-br from-glico-verde to-glico-verde_escuro text-white p-12 flex-col justify-between">
    <svg class="gota absolute -right-16 -bottom-16 w-96 h-96 opacity-20" fill="currentColor" viewBox="0 0 100 100" aria-hidden="true">
      <path d="M50 10C50 10 20 45 20 65C20 81.56 33.43 95 50 95C66.57 95 80 81.56 80 65C80 45 50 10 50 10Z" />
    </svg>
    <svg class="gota gota-2 absolute left-10 top-1/3 w-24 h-24 opacity-10" fill="currentColor" viewBox="0 0 100 100" aria-hidden="true">
      <path d="M50 10C50 10 20 45 20 65C20 81.56 33.43 95 50 95C66.57 95 80 81.56 80 65C80 45 50 10 50 10Z" />
    </svg>

    <glico-logo class="relative z-10" [branco]="true" [tamanho]="40" classeNome="text-2xl" [animar]="true"></glico-logo>

    <div class="relative z-10 max-w-md space-y-8">
      <div class="animate-fade-up" style="animation-delay: 150ms">
        <p class="text-glico-verde_claro font-semibold text-sm uppercase tracking-wide mb-2">Painel de gestão</p>
        <h1 class="text-4xl font-extrabold leading-tight m-0 text-white">Acompanhe cada paciente com cuidado e proximidade.</h1>
      </div>

      <!-- Card de Simulação de Mensagem do WhatsApp -->
      <div class="flex gap-4 animate-fade-up" style="animation-delay: 350ms">
        <div class="flex-shrink-0">
          <div class="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm border border-gray-100">
            <glico-logo [tamanho]="20" [comNome]="false"></glico-logo>
          </div>
        </div>
        <div>
          <p class="text-sm font-bold text-white mb-1 mt-0">
            Glicosus <span class="text-xs font-normal text-glico-verde_claro ml-2">Agora mesmo</span>
          </p>
          @if (digitando) {
            <div class="bg-white rounded-2xl rounded-tl-none shadow-sm inline-flex gap-1.5 px-4 py-3" aria-label="Glicosus está digitando">
              <span class="w-2 h-2 rounded-full bg-glico-verde animate-typing" style="animation-delay: 150ms"></span>
              <span class="w-2 h-2 rounded-full bg-glico-verde animate-typing" style="animation-delay: 300ms"></span>
              <span class="w-2 h-2 rounded-full bg-glico-verde animate-typing" style="animation-delay: 450ms"></span>
            </div>
          } @else {
            <div class="text-gray-700 text-sm bg-white p-3 rounded-2xl rounded-tl-none shadow-sm inline-block animate-pop-in">
              Olá! ☀️ Vi sua medição de jejum. Está ótima! Vamos manter o ritmo hoje? Lembre-se de beber água.
            </div>
          }
        </div>
      </div>
    </div>

    <p class="relative z-10 text-sm text-glico-verde_claro m-0">Acompanhamento de glicemia com lembretes no WhatsApp.</p>
  </aside>

  <!-- Formulário -->
  <main class="flex flex-col items-center justify-center px-4 py-10 sm:px-8">
    <div class="w-full max-w-md">
      <glico-logo class="lg:hidden flex justify-center mb-8" [tamanho]="48" classeNome="text-3xl" [animar]="true" [flutuar]="true"></glico-logo>

      <header class="mb-8 text-center lg:text-left animate-fade-up" style="animation-delay: 100ms">
        <h2 class="text-3xl font-extrabold text-glico-texto m-0">{{ titulo }}</h2>
        @if (subtitulo) {
          <p class="text-gray-500 mt-2 mb-0">{{ subtitulo }}</p>
        }
      </header>

      <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 animate-fade-up" style="animation-delay: 200ms">
        <ng-content></ng-content>
      </div>
    </div>
  </main>
</div>
